import { getStageParams, resetMetricsParams, setStageParams } from "./metrics-context";

let stages: string[] = [];

export const resetAdStages = () => {
  stages = [];
  resetMetricsParams();
};

export const pushAdStage = (stage: string) => {
  if (!stage) return;
  const last = stages[stages.length - 1];
  if (last === stage) return;
  stages.push(stage);
  const history = stages.join(">");
  setStageParams({
    ad_stage: stage,
    ad_stage_history: history
  });
};

export const getAdStageParams = () => ({
  ...getStageParams(),
  ad_stage_history: stages.join(">")
});
